import { DYNAMIC_ISLAND } from "../../../config/dynamicIsland.configuration";
import {
    type DynamicIslandShellMotionConfig,
    type DynamicIslandShellVariants,
} from "./dynamicIslandAnimation.types";

/**
 * Default shell motion presets sourced from {@link DYNAMIC_ISLAND.animations}.
 *
 * @returns Baseline shell motion config before variant overrides.
 */
export function getDefaultDynamicIslandShellMotion(): DynamicIslandShellMotionConfig {
    const { animations } = DYNAMIC_ISLAND;

    const shell: DynamicIslandShellVariants = {
        "enter":      animations.shell.enter,
        "exit":       animations.shell.exit,
        "kindSwitch": animations.shell.kindSwitch,
        "staggerMs":  animations.shell.staggerMs,
    };

    return {
        "spring":                animations.spring,
        "maxWidthPercent":       animations.maxWidthPercent,
        shell,
        "rtTextPulseDebounceMs": animations.rtTextPulseDebounceMs,
    };
}
